const NON_ALPHANUM = /[^a-zA-Z0-9]/g;
const EVERY_FOUR_CHARS = /(.{4})(?!$)/g;
/**
 * Formats an IBAN string by removing non-alphanumeric characters and adding a space every four characters.
 *
 * @param {string} iban - The IBAN string to format.
 * @returns {string} The formatted IBAN string with spaces every four characters.
 */ export const formatIban = (iban)=>iban.replace(NON_ALPHANUM, '').replace(EVERY_FOUR_CHARS, '$1 ').toUpperCase();
/**
 * Adjusts the cursor position after formatting an IBAN string.
 *
 * @param {number} originalCursorPosition - The original position of the cursor before formatting.
 * @param {number} originalLength - The original length of the unformatted IBAN string.
 * @param {string} formattedValue - The formatted IBAN string.
 * @returns {number} The adjusted cursor position after formatting.
 */ export const getCursorPosition = (originalCursorPosition, originalLength, formattedValue)=>{
    const needsExtraSpace = formattedValue.charAt(originalCursorPosition - 1) === ' ' && originalLength !== formattedValue.length;
    return originalCursorPosition + (needsExtraSpace ? 1 : 0);
};

//# sourceMappingURL=iban.js.map